// ------------------------------------
// Organization Message links
// ------------------------------------
const messagesLink = (orgId) => `/organizations/${orgId}/messages`;

export { messagesLink };
